const checkMobileKate = () => {
  return navigator.userAgent.toLowerCase().includes('mobilekate');
};

const checkMoileClickDenyUrl = (url: string) => {

  return process.env.REACT_APP_MOBILE_REDIRECT_DENY_URL?.split("||").includes(new URL(url).hostname);
}

export { checkMobileKate, checkMoileClickDenyUrl };
